package com.appcreator.blueprint.actions.data

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.ActionClass
import com.appcreator.blueprint.core.InputProperty
import com.appcreator.blueprint.core.StringDefault
import com.appcreator.blueprint.core.properties.DataPath
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("SetValue")
@ActionClass(
    group = "Data",
    title = "Update Value",
    availableFrom = "0.0.1"
)
class SetValueAction(
    @InputProperty(
        title = "Key",
        availableFrom = "0.0.1",
        settableDataOnly = true
    )
    val key: DataPath?,
    @InputProperty(
        title = "Value",
        availableFrom = "0.0.1"
    )
    @StringDefault("")
    val value: String,

    @InputProperty(
        title = "Skip if value empty",
        availableFrom = "0.0.1"
    )
    val skipIfEmpty: Boolean?,
): Action
